export const parseYYYYMMDD = (date: YYYYMMDDDateString): Date => {
  const [year, month, day] = date.split('-').map(Number)

  return new Date(year, month - 1, day)
}
